// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const GoalEditorPanelLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-goaleditorpanel" */ "./GoalEditorPanel")).then((bundle)=>{
        return {
            default: bundle.GoalEditorPanel
        };
    });
export const LazyGoalEditorPanel = /*#__PURE__*/ lazy(GoalEditorPanelLazyLoader);
